<div class="tasks-dashboard new-input-fields">
  <div class="row filter-row top-row">
    <div class="small-12 medium-12 columns view-option-wrapper text-right add-data" *ngIf="!isClientDashboard">
        <span class="float-right">
          <i class="icon ion-ios-cloud-download-outline" style="margin-right:10px; font-size: 1.5rem"
             (click)="exportTasksinList()"></i>
        </span>
      <span class="float-right text-left tasks-filter" style="margin-right: 10px;position: relative;top:3px;">
          <tasks-search [tags]="filters"></tasks-search>
        </span>
      <div class="compose-post float-right" style="margin-top: 5px; margin-bottom: 5px;" (click)="openCreateTaskPopup()">
        <i class="material-icons">add</i><span>TASK</span>
      </div>
    </div>
    <div class="small-12 medium-12 columns">
      <div class="row">
        <div class="small-12 medium-3 columns">
          <div *ngIf="clearDaysFilter">
            <label>
              <app-tpiq-select-dropdown [setData]="tasksDays" [setPlaceHolder]="'Date Filter'" [includeNone]="false"
                                     [setSearchKey]="'name'" [setValueKey]="'id'"
                                     (onValueSelect)="onDateFilterSelect($event)"
                                     [setDefaultValue]="selectedTaskDay['id']"></app-tpiq-select-dropdown>
            </label>
          </div>
        </div>
        <div class="small-12 medium-3 columns">
          <div class="filter-option-wrapper-max filter-option-wrapper-min">
            <ng-multiselect-dropdown *ngIf="multiselectReady"
              name="Status"
              [placeholder]="'Status'"
              [settings]="statusdropdownSettings"
              [data]="tasksStatus"
              [(ngModel)]="selectedStatuses"
              (onSelect)="onStatusFilterSelect($event, true)"
              (onDeSelect)="onStatusFilterSelect($event, false)"
              (onSelectAll)="onAllStatusFilterSelect($event, true)"
              (onDeSelectAll)="onAllStatusFilterSelect($event, false)">
            </ng-multiselect-dropdown>
          </div>
        </div>
        <div class="small-12 medium-3 columns">
          <div class="filter-option-wrapper-max" [hidden]="isClientDashboard">
            <ng-multiselect-dropdown *ngIf="multiselectReady"
              name="company"
              [placeholder]="'Client'"
              [settings]="companydropdownSettings"
              [data]="clientCompaniesList"
              [(ngModel)]="selectedCompanies"
              (onSelect)="onCompanyFilterSelect($event, true)"
              (onDeSelect)="onCompanyFilterSelect($event, false)"
              (onSelectAll)="onAllCompaniesFilterSelect($event, true)"
              (onDeSelectAll)="onAllCompaniesFilterSelect($event, false)">
            </ng-multiselect-dropdown>
          </div>
        </div>
        <div class="small-12 medium-3 columns">
          <div id="assignee-dropdown"
               class="filter-option-wrapper-max filter-option-wrapper-min zero-margin-right">
            <ng-multiselect-dropdown *ngIf="multiselectReady"
              name="Assignees"
              [placeholder]="'Assigned'"
              [settings]="assigneedropdownSettings"
              [data]="users"
              [(ngModel)]="selectedAssignees"
              (onSelect)="onAssigneeFilterSelect($event, true)"
              (onDeSelect)="onAssigneeFilterSelect($event, false)"
              (onSelectAll)="onAllAssigneesFilterSelect($event, true)"
              (onDeSelectAll)="onAllAssigneesFilterSelect($event, false)">
            </ng-multiselect-dropdown>
          </div>
        </div>
      </div>
    </div>
    <div class="small-12 medium-2 columns till-date" *ngIf="filterObj.date == 'Custom'">
      <label>
        <input class="round-border" type="text" tpiq-custom-datepicker [format]="dateFormat" [mindate]="'past'"
               (valueChanged)="setFromDate($event)" placeholder="From Date" [defaultValue]="filterObj.fromDate">
      </label>
    </div>
    <div class="small-12 medium-2 columns till-date" *ngIf="filterObj.date == 'Custom'">
      <label>
        <input class="round-border" type="text" tpiq-custom-datepicker [format]="dateFormat" [mindate]="'past'"
               (valueChanged)="setToDate($event)" placeholder="To Date" [defaultValue]="filterObj.toDate">
      </label>
    </div>
  </div>

  <!--List view-->
  <div class="tasks-list-view tracker-page" *ngIf="showListView">
    <div class="row" *ngIf="hasTasks && isClientInfo">
      <div class="column medium-12">
        <div class="float-right">
          <tasks-search [tags]="filters"></tasks-search>
        </div>
      </div>
    </div>
    <div class="row no-tasks-wrapper" *ngIf="totalCount==0 && hasTasks">
      <div class="small-12 medium-12 columns">
        <div class="no-tasks-text">
          No Tasks Available !!
        </div>
      </div>
    </div>
    <div class="row" *ngIf="totalCount>0">
      <div class="row add-share-buttons" style="margin-left: 2rem; width: 20vw;">
        <div class="medium-10 small-12 invoice-dropdown" foundation
             [ngStyle]="{'display': selectedTableRows.length>0 ? 'block':'none'}">
          <button class="dropdown button" type="button" data-toggle="recent-actions">Action</button>
          <ul class="dropdown-pane" id="recent-actions" data-dropdown data-close-on-click="true">
            <li class="pointer" *ngFor="let action of actions"
                (click)="handleMultipleActions(action.value,action.name)"><span class="icon"
                                                                                [ngClass]="action.className"></span><span>{{action.name}}</span>
            </li>
          </ul>
        </div>
        <div class="column medium-2 selection-count" style="margin-top: 6px"
             [ngStyle]="{'display': selectedTableRows.length>0 ? 'block':'none'}">
          <span>{{selectedTableRows.length}}</span><span style="padding-left: 5px">selected</span></div>
      </div>

      <div class="column medium-12 large-12 indy-tables badge-tables mt-3">
        <app-tracker-paginated-table #tasksTable [setObj]="tasksTableData" *ngIf="hasTasks"
                                 (onRowAction)="handleTasksTableAction($event)"
                                 (onSort)="sortByColumn($event)" (onScroll)="handleListViewScroll($event)"
                                 (onInputBlur)="updateInput($event)"
                                 (onDropdownSelection)="updateStatus($event)"
                                 (onInputSearchSelection)="optionSelected($event)"
                                 (onStatusMove)="moveNextStatus($event)"
                                 (onRowSelect)="handleSelect($event)"></app-tracker-paginated-table>
      </div>
    </div>
  </div>
</div>

<div class="actions" *ngIf="reveal['flag']">
  <div class="reveal-overlay" (click)="hideReveal('flag')" [ngClass]="{'tpiq-reveal': reveal['flag']}"></div>
  <div class="reveal actions-reveal" [ngClass]="{'tpiq-reveal': reveal['flag']}">
    <div class="row header">
      <div class="small-12 columns">
        <label *ngIf="flagValue == 'duedate'" class="wakeup-text">Select Due Date for Selected Tasks !!</label>
        <label *ngIf="flagValue == 'status'" class="wakeup-text">Select Status for Selected Tasks !!</label>
        <label *ngIf="flagValue == 'priority'" class="wakeup-text">Select Priority for Selected Tasks !!</label>
        <label *ngIf="flagValue == 'assign'" class="wakeup-text">Select Assignee for selected Tasks !!</label>
        <label *ngIf="flagValue == 'reassign'" class="wakeup-text">Reassign Assignee for selected Tasks
          !!</label>
        <label *ngIf="flagValue == 'delete'" class="wakeup-text">Are you sure to Delete selected Tasks?</label>
      </div>
    </div>

    <div *ngIf="flagValue == 'duedate'">
      <div class="row label-top">
        <div class="small-4 medium-3 columns">
          <label class="label-name label-top">Due Date</label>
        </div>
        <div class="small-4 medium-6 columns">
          <label>
            <input class="round-border" type="text" tpiq-custom-datepicker [container]="'due_date'"
                   [format]="'MM/DD/YYYY'" [mindate]="'past'" placeholder="Date"
                   (valueChanged)="onBulkDueDateSelect($event)">
            <div id="due_date"></div>
          </label>
        </div>
      </div>
    </div>

    <div *ngIf="flagValue == 'status'">
      <div class="row label-top">
        <div class="small-4 medium-3 columns">
          <label class="label-name label-top">Status</label>
        </div>
        <div class="small-4 medium-6 columns">
          <label>
            <app-tpiq-select-dropdown [setData]="statusTypes" [setPlaceHolder]="'Select Status'"
                                   [includeNone]="false" [setSearchKey]="'status'" [setValueKey]="'id'"
                                   (onValueSelect)="onBulkStatusSelect($event)"></app-tpiq-select-dropdown>
          </label>
        </div>
      </div>
    </div>

    <div *ngIf="flagValue == 'priority'">
      <div class="row label-top">
        <div class="small-4 medium-3 columns">
          <label class="label-name label-top">Priority</label>
        </div>
        <div class="small-4 medium-6 columns">
          <label>
            <app-tpiq-select-dropdown [setData]="priorities" [setPlaceHolder]="'Select Priority'"
                                   [includeNone]="false" [setSearchKey]="'name'" [setValueKey]="'id'"
                                   (onValueSelect)="onBulkPrioritySelect($event)"></app-tpiq-select-dropdown>
          </label>
        </div>
      </div>
    </div>

    <div *ngIf="flagValue == 'assign' || flagValue == 'reassign'">
      <div class="row label-top">
        <div class="small-4 medium-3 columns">
          <label class="label-name label-top">Assignee</label>
        </div>
        <div class="small-4 medium-6 columns">
          <label>
            <app-tpiq-select-dropdown [setData]="users" [setPlaceHolder]="'Select Assignee'"
                                   [includeNone]="false" [setSearchKey]="'name'" [setValueKey]="'id'"
                                   (onValueSelect)="onBulkAssigneeSelect($event)"></app-tpiq-select-dropdown>
          </label>
        </div>
      </div>
    </div>

    <div class="row footer">
      <div class="small-12 medium-12 columns btn-row">
        <div class="text-right btn-wrapper" style="padding-right: 10px">
          <button class="button small" (click)="onSubmit(flagValue)">APPLY</button>
          <button class="button small" style="background: #f1645a;" (click)="hideReveal('flag')">CANCEL
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="reveal['taskCreation']">
  <div class="reveal-overlay" [ngClass]="{'tpiq-reveal': reveal['taskCreation']}">
  </div>
  <div class="reveal tax-strategy-reveal" style="padding: 0; border: none; width: 40%;" [ngClass]="{'tpiq-reveal': reveal['taskCreation']}">
    <div class="header" style="height: 50px; background-color: #5376E3; padding: 15px; color: #fff;">
      <span class="float-left">Task Creation</span>
      <span class="float-right pointer" (click)="hideReveal('taskCreation')">X</span>
    </div>
    <div class="body" style="padding: 15px;">
      <div class="row" style="padding-bottom: 15px;">
        <div class="medium-10 columns">
          <label>
            Client:
            <app-tpiq-select-dropdown [setData]="clientCompaniesList" [includeNone]="false" (onValueSelect)="onClientSelect($event)"
                                   [setDefaultValue]="" [setSearchKey]="'name'" [setPlaceHolder]="'Select a client'" [setValueKey]="'id'"></app-tpiq-select-dropdown>
          </label>
        </div>
      </div>
      <div class="row"  *ngIf="selectedClient" style="padding-bottom: 15px;">
        <div class="medium-10 columns">
          <label>
            Plan:
            <app-tpiq-select-dropdown [setData]="clientPlans" [includeNone]="false" (onValueSelect)="onClientPlanSelect($event)"
                                   [setDefaultValue]="" [setSearchKey]="'name'" [setPlaceHolder]="'Select a plan'" [setValueKey]="'id'"></app-tpiq-select-dropdown>
          </label>
        </div>
      </div>
      <div class="row"  *ngIf="selectedPlan" style="padding-bottom: 15px;">
        <div class="medium-10 columns">
          <label>
            Strategy:
            <app-tpiq-select-dropdown [setData]="planStrategies" [includeNone]="false" (onValueSelect)="onPlanStrategySelect($event)"
                                   [setDefaultValue]="" [setSearchKey]="'strategyName'" [setPlaceHolder]="'Select a strategy'" [setValueKey]="'strategyId'"></app-tpiq-select-dropdown>
          </label>
          <span style="font-size: 12px;">Note: Strategies with no goal date.</span>
        </div>
      </div>
      <div class="row" style="padding-bottom: 15px;" *ngIf="selectedPlanStrategy">
        <div class="medium-10 columns">
          <label>
            <span>Create Task Date</span>
            <span class="text-center badge-tooltip">
              <i class="icon ion-ios-information-outline"></i><span class="pe-2">:</span>
              <span class="bottomTooltiptext" style="width: 250px; margin-left: -100px;">
                A task will be created for the strategy once you fill in the task date field here.
              </span>
            </span>
            <input class="float-left input-field" type="text" tpiq-custom-datepicker [attr.format]="'MM/DD/YYYY'" [mindate]="'past'" [(ngModel)]="taskGoalDate"
                   placeholder="Create Task Date" (valueChanged)="setGoalDate($event)"/>
          </label>
        </div>
      </div>
      <div class="row">
        <div class="medium-12 columns">
          <button style="margin-top: 15px;" class="button small float-right" (click)="createTask()">CREATE</button>
        </div>
      </div>
    </div>
  </div>
</div>
